/**
 * The `PathParser` is used by the `parsePathString` static method
 * to generate a `pathArray`.
 */
var PathParser = /** @class */ (function () {
    function PathParser(pathString) {
        this.pathValue = pathString;
        // @ts-ignore
        this.segments = [];
        this.max = pathString.length;
        this.index = 0;
        this.param = 0.0;
        this.segmentStart = 0;
        this.data = [];
        this.err = '';
    }
    return PathParser;
}());
export { PathParser };
//# sourceMappingURL=path-parser.js.map